/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */


import API from '@/api/';
import jwt from 'jsonwebtoken';
import {
  CLEAR,
} from './mutation-types';

export const clearAllStore = ({commit, dispatch}) => {
  commit(CLEAR);
  dispatch('clearOtherModules');
}

export const clearOtherModules = ({commit}) => {
  //@todo reset all other store
  commit(`asset/CLEAR`, null, { root: true });
  commit(`channel/CLEAR`, null, { root: true });
  commit(`chnlOrgWhitelist/CLEAR`, null, { root: true });
  commit(`chnlWhitelist/CLEAR`, null, { root: true });
  commit(`department/CLEAR`, null, { root: true });
  commit(`deptMember/CLEAR`, null, { root: true });
  commit(`group/CLEAR`, null, { root: true });
  commit(`groupDeptMember/CLEAR`, null, { root: true });
  commit(`member/CLEAR`, null, { root: true });
  commit(`organization/CLEAR`, null, { root: true });
  commit(`recshare/CLEAR`, null, { root: true });
  commit(`user/CLEAR`, null, { root: true });

  /*
  commit(`account/CLEAR`, null, {
    root: true
  });
  commit(`audio/CLEAR`, null, {
    root: true
  });
  commit(`category/CLEAR`, null, {
    root: true
  });
  commit(`group/CLEAR`, null, {
    root: true
  });
  commit(`tag/CLEAR`, null, {
    root: true
  });
  commit(`user/CLEAR`, null, {
    root: true
  });
  */
}

export const logout = ({ dispatch }) => {
  return new Promise((resolve) => {
    localStorage.removeItem('access_token')
    dispatch('clearAllStore');
    resolve()
  })
}
export const login = ({ commit, dispatch },params) => {
  return new Promise((resolve) => {
    API.auth.login(params).then(res => {
      if (res.status === 201) {
        const decoded = jwt.decode(res.data.access_token)
        //console.log(`auth.login: decoded = ${JSON.stringify(decoded)}`);
        localStorage.setItem('access_token',res.data.access_token)
        commit('updateByToken', {access_token: res.data.access_token, decoded});
        dispatch('clearOtherModules');
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  })
}

//@todo: solve eslint error
export const refresh = ({commit, dispatch}, params) => {
  return new Promise((resolve, reject) => {
    console.log(`running refresh`);
    API.auth.refresh(params).then(res => {
      if (res.status === 201) {
        const decoded = jwt.decode(res.data.access_token)
        //console.log(`auth.refresh: decoded = ${JSON.stringify(decoded)}`);
        localStorage.setItem('access_token', res.data.access_token)
        commit('updateByToken', {access_token: res.data.access_token, decoded});
        resolve(res)
      } else {
        //console.log(`app: refresh non-401, status code = ${res.status}`);
        localStorage.removeItem('access_token')
        commit(CLEAR)
        dispatch('clearOtherModules');
        reject(`status code = ${res.status}`);
      }
    }) 
    .catch(err => {
      //console.log(`refresh: inner catch`); 
      localStorage.removeItem('access_token')
      commit(CLEAR)
      dispatch('clearOtherModules');
      reject(err);
    })
  })
}

export const updatePassword = ({ commit },params) => {
  return new Promise((resolve) => {
    API.auth.updatePassword(params).then(res => {
      if (res.status === 200) {
        const decoded = jwt.decode(res.data.access_token)
        localStorage.setItem('access_token',res.data.access_token)
        commit('updateByToken', {access_token: res.data.access_token, decoded});
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  })
}
export default {
  clearAllStore,
  clearOtherModules,
  login,
  refresh,
  logout,
  updatePassword
};
